/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioMensaRendicontazioneDTO { 
    id?: string;
    mese_rendicontazione?: number;
    numero_giorni_rendicontati_su_mese?: number;
    importo_previsto?: number;
    disavanzo?: number;
    importo?: number;
    disabilitata?: boolean;
    ricarica_id?: string;
}

